export default __webpack_public_path__ + "media/images/user_photos/125-b7d0a4f1025daf67b0f80bff228f2741.jpg";